import React from "react";
import styles from "./ModalPayment.module.css";
import BtnTwitter from "../../../components/Btn/BtnTwitter/BtnTwitter";
import BtnLine from "../../../components/Btn/BtnLine/BtnLine";
import BtnShare from "../../../components/Btn/BtnShare/BtnShare";

const ERROR_MSG =
  "エラー：このページのURLをクリップボードにコピーしようとしましたが、失敗しました。";

const makeLineShareURL = (targetUrl: string): string => {
  const getParams = new URLSearchParams();
  getParams.append("url", targetUrl);

  return `https://social-plugins.line.me/lineit/share?${getParams.toString()}`;
};

const makeTwitterShareURL = (
  targetUrl: string,
  projectName: string
): string => {
  const getParams = new URLSearchParams();
  getParams.append("url", targetUrl);
  getParams.append("text", `『${projectName}』を購入しました！ #TALTO`);

  return `https://twitter.com/intent/tweet?${getParams.toString()}`;
};

type ShareButtonsProps = {
  projectName: string;
};

const ShareButtons: React.FC<ShareButtonsProps> = ({ projectName }) => {
  const shareUrl = window.location.href;
  const lineHref = makeLineShareURL(shareUrl);
  const twitterHref = makeTwitterShareURL(shareUrl, projectName);

  const copyProjectUrlToClickboard = () => {
    if (!navigator.clipboard) {
      alert(ERROR_MSG);
    }

    navigator.clipboard
      .writeText(shareUrl)
      .then(() => alert("URLをクリップボードにコピーしました"))
      .catch(() => alert(ERROR_MSG));
  };
  return (
    <>
      <p className={styles.border}>購入した作品をシェア</p>
      <ul className={styles.share}>
        <li>
          <a href={twitterHref} target="_blank" rel="noreferrer">
            <BtnTwitter></BtnTwitter>
          </a>
        </li>
        <li>
          <a href={lineHref} target="_blank" rel="noreferrer">
            <BtnLine></BtnLine>
          </a>
        </li>
        <li onClick={copyProjectUrlToClickboard}>
          <BtnShare></BtnShare>
        </li>
      </ul>
    </>
  );
};

export default ShareButtons;
